import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BazowyComponent } from 'src/app/komponenty/bazowy.component';
import { TakNieModalComponent } from 'src/app/komponenty/ogolne/tak-nie-modal/tak-nie-modal.component';
import {
  EdytujFiltrPorownywaniaDanychModel,
  KolumnaFiltraPorownywaniaDanych,
} from 'src/app/modele/projekty/magazyny/edytujFiltrPorownywaniaDanychModel';
import { ComboBox } from 'src/app/modele/wspolne/comboBox';
import { ModalOpcje } from 'src/app/modele/wspolne/modal-opcje.ogolne';
import { AuthService } from 'src/app/serwisy/ogolne/auth.service';
import { LoaderService } from 'src/app/serwisy/ogolne/loader.service';
import { PolaSpisuService } from 'src/app/serwisy/projekty/pola-spisu.service';
import { PorownywanieDanychService } from 'src/app/serwisy/projekty/porownywanie-danych.service';
import { ProjektyService } from 'src/app/serwisy/projekty/projekty.service';
import { SlownikiService } from 'src/app/serwisy/projekty/slowniki.service';

@Component({
  selector: 'app-edytuj-filtr-porownywania-danych-modal',
  templateUrl: './edytuj-filtr-porownywania-danych-modal.component.html',
  styleUrls: ['./edytuj-filtr-porownywania-danych-modal.component.css'],
})
export class EdytujFiltrPorownywaniaDanychModalComponent
  extends BazowyComponent
  implements OnInit
{
  czyZaladowanoDane: boolean;
  kolumny: Array<KolumnaFiltraPorownywaniaDanych> = new Array();
  polaSpisu: Array<ComboBox> = new Array();
  idProjektu: string;
  idLokalizacji: string;
  idFiltra: string;
  model: EdytujFiltrPorownywaniaDanychModel =
    new EdytujFiltrPorownywaniaDanychModel();

  constructor(
    public router: Router,
    modalService: NgbModal,
    public activeModal: NgbActiveModal,
    loaderSerwis: LoaderService,
    komunikatSerwis: ToastrService,
    public authService: AuthService,
    public polaSpisuSerwis: PolaSpisuService,
    public slownikiSerwis: SlownikiService,
    public translateSerwis: TranslateService,
    private activatedRoute: ActivatedRoute,
    private projektSerwis: ProjektyService,
    private porownywanieDanychSerwis: PorownywanieDanychService
  ) {
    super(
      authService,
      modalService,
      loaderSerwis,
      komunikatSerwis,
      router,
      translateSerwis
    );
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.pobierzDaneDoEkranu();
    });
  }

  pobierzDaneDoEkranu() {
    this.model.pokaz = 0;
    this.porownywanieDanychSerwis
      .pobierzDaneDoEdycjiFiltra(
        this.idProjektu,
        this.idLokalizacji,
        this.idFiltra
      )
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.polaSpisu = rezultat.element.polaSpisu;

          if (this.idFiltra) {
            this.model = rezultat.element.filtr;
          }

          this.model.kolumny = rezultat.element.kolumny;

          this.czyZaladowanoDane = true;
          return;
        }
        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  zapisz() {
    this.model.idProjektu = this.idProjektu;
    this.model.id = this.idFiltra;
    this.porownywanieDanychSerwis
      .zapiszFiltr(this.model)
      .subscribe((rezultat) => {
        if (this.czyRezultatOk(rezultat)) {
          this.wyswietlKomunikat('Zapisano poprawnie');
          this.activeModal.close(true);
          return;
        }
        if (this.bladModelu(rezultat)) {
          this.bledyWalidacji = rezultat.bledyModelu;
          return;
        }

        this.wyswietlKomunikat(rezultat.wiadomosc, true);
        return;
      });
  }

  usun() {
    this.modalReference = this.modalService.open(
      TakNieModalComponent,
      new ModalOpcje(true, 'static')
    );
    this.modalReference.componentInstance.pytanie =
      'Czy na pewno chcesz usunąć filtr?';

    this.modalReference.result.then(
      (result) => {
        if (result) {
          this.porownywanieDanychSerwis
            .usunFiltr(this.idFiltra)
            .subscribe((rezultat) => {
              if (this.czyRezultatOk(rezultat)) {
                this.wyswietlKomunikat('Filtr został usunięty');
                this.activeModal.close(true);
                return;
              }

              this.wyswietlKomunikat(rezultat.wiadomosc, true);
              return;
            });
        }
      },
      (onRejected) => {}
    );
  }

  get kolumnyDodatkowychPol() {
    var kolumny = this.model.kolumny.filter(
      (m) => !this.model.polaSpisuId.includes(m.id)
    );
    console.log(kolumny);
    return kolumny;
  }
}
